import { DamageType, DetailCarDTO } from '../modules/generated/api';

import DamageTypeHighlights from './DamageTypeHighlights';
import Highlights from './Highlights';

type CarDetailTileHighlightsProps = {
  car: DetailCarDTO;
  damageType?: Array<DamageType>;
};

const CarDetailTileHighlights = ({ car, damageType }: CarDetailTileHighlightsProps) => (
  <Highlights car={car}>
    <DamageTypeHighlights damageType={damageType} />
  </Highlights>
);

export default CarDetailTileHighlights;
